import { imagesBcp } from '@assets';
import {
	AlternativeStylesPropertiesTypography,
	Box,
	Image,
	Spacer,
	Typography,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { Color } from '@types';
import { useMembershipCompletionTitleHelper } from './membershipCompletionTitle.helper';

type TypographyStyles = React.CSSProperties & AlternativeStylesPropertiesTypography;

export const MembershipCompletionTitle: React.FC = () => {
	const { icon, iconBgColor, statusDescription, selectedPlanName } = useMembershipCompletionTitleHelper();
	const { palette } = useTheme();
	return (
		<Box styles={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
			<Spacer vertical={rem(36)} />
			<Box styles={{ position: 'relative' }}>
				<Box
					styles={{
						backgroundColor: iconBgColor,
						borderRadius: '50%',
						position: 'absolute',
						top: 0,
						left: '50%',
						transform: 'translateX(-50%) translateY(-50%)',
						padding: rem(4),
					}}
				>
					{icon}
				</Box>
				<Box
				// styles={{
				// 	backgroundColor: palette.global.ui18,
				// 	borderRadius: rem(16),
				// 	overflow: 'hidden',
				// 	backfaceVisibility: 'hidden',
				// }}
				>
					<Image source={imagesBcp.planTitleBrand} />
					<Box styles={{ alignItems: 'center', padding: rem(0, 40, 0, 8) }}>
						<Typography
							appearance="subtitle-200-02"
							alternativeStyleProperties={{ color: Color.Izibizi } as TypographyStyles}
						>
							{selectedPlanName}
						</Typography>
					</Box>
				</Box>
			</Box>
			<Spacer vertical={rem(40)} />
			<Typography
				appearance="headline-200-02"
				styles={{ wordBreak: 'break-all', textAlign: 'center' } as TypographyStyles}
			>
				{statusDescription}
			</Typography>
			<Spacer vertical={rem(80)} />
		</Box>
	);
};
